<body>

      <div *ngIf="!isOnline" class="offline-message">
        <p>❌ Vous êtes hors ligne. Vérifiez votre connexion internet.</p>
      </div>

      <div *ngIf="isOnline">
        <!-- Contenu de Home2 -->
        <section class="hero" >
          <div class="hero1" >
            <svg class="background-shape" viewBox="0 0 100 100" preserveAspectRatio="none">
              <path d="M0,0 L100,0 L100,100 Q50,80 0,100 Z" fill="url(#grad)" />
              <defs>
                <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style="stop-color:var(--primary-color);stop-opacity:1" />
                  <stop offset="100%" style="stop-color:var(--secondary-color);stop-opacity:1" />
                </linearGradient>
              </defs>
            </svg>
            
            <div class="hero-content" >
              <!--<img class="logo" src="https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/Lenali%20Logo%20sans%20fond.png?alt=media&token=baaba23a-4809-4785-a5d2-a4b8f9f05f3f" alt="">
            -->
            
              <!-- Bouton Play/Pause -->
              <!--<div class="audio-container" >
                <button class="play-pause-button" (click)="toggleAudio()">
                  <mat-icon>{{ isPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
                </button>
                <audio #audioPlayer preload="auto" src="assets/audio/01_Bambara_Choix_Num_Email.m4a"></audio>
            
              </div>-->

              <!-- Image Lenali -->
              <div class="box-for-logo">
                <img src="../../../assets/images/Lenali_logo_Full.png" alt="Lenali Logo" class="lenali-logo title">
              </div>

              <div style="margin-bottom: 70px; ">
                
              </div>
              <!--<h1 class="title">Lenali</h1>
              <p class="subtitle">Communicate Freely</p>-->
              
              
              <div class="button-container">
                <!-- Bouton pour le numéro -->
                <button  color="primary" class="cta-button" (click)="onGetStartedClick2()">
                  <mat-icon>phone</mat-icon>
                  Continuer avec le N° de téléphone
                </button>
              </div>
              
              <br>
              
              <div class="button-container button-container2">
                <!-- Bouton pour l'email -->
                <button  color="accent" class="cta-button" (click)="onGetStartedClick()">
                  <mat-icon>email</mat-icon>
                  Continuer avec l'adresse email
                </button>
              </div>

              <br>
              
              <div class="button-container button-container2">
                <!-- Bouton pour l'email -->
                <button  color="accent" class="cta-button" (click)="onGetStartedClick3()">
                  <mat-icon>person_off</mat-icon>
                  Authentification anonyme
                </button>
              </div>
      
            </div>
          </div>
        </section>
        
      </div>
    
    
    <script>
    document.addEventListener('DOMContentLoaded', () => {
      const hero = document.querySelector('.hero');
      const title = document.querySelector('.title');
      const subtitle = document.querySelector('.subtitle');
      const button = document.querySelector('.cta-button');
    
      
    
      hero.addEventListener('mousemove', (e) => {
        if (Math.random() < 0.1) {
          createParticle(e.clientX, e.clientY);
        }
      });
    
     
    
      
    });
    </script>
    </body>